import { Form, Spin } from 'antd';
import { useMutation } from 'react-query';
import useHttpClient from '../../../shared/sendRequest/useHttpClient';
import EndPoints from '../../../shared/endPoints/EndPoints.json';
import AuthLayout from '../../../components/AuthLayout/AuthLayout';
import AuthCard from '../../../components/AuthCard/AuthCard';
import useAuthFlowRouteGuard from '../../../shared/hooks/useAuthFlowRouteGuard';
import { useAuthFlowContext } from '../../../shared/context/auth-flow-context';
import { useAuthContext } from '../../../shared/context/auth-context';
import NewPasswordFields from './NewPasswordFields';
import PasswordSubmitButton from './PasswordSubmitButton';

export default function SetPassword() {
  const { login } = useAuthContext();
  const [form] = Form.useForm();
  const { sendRequest } = useHttpClient();
  const { tempCode } = useAuthFlowContext();
  const shouldRender = useAuthFlowRouteGuard(!!tempCode);

  const { mutate, isLoading } = useMutation(sendRequest, {
    onSuccess: data => {
      login(data?.accessToken, false);
    },
    onSettled: () => {
      form.resetFields();
    }
  });

  if (!shouldRender) return null;

  const onFinish = values => {
    mutate({
      endpoint: EndPoints.USERACCOUNT.SETPASSWORD,
      method: 'POST',
      bodyData: {
        tempCode,
        password: values.password,
        confirmPassword: values.confirmPassword
      }
    });
  };

  return (
    <AuthLayout>
      <Spin spinning={isLoading} size="large">
        <AuthCard
          title="Δημιουργία Κωδικού"
          subtitle="Κράτησε το λογαριασμό σου ασφαλή ορίζοντας έναν ισχυρό κωδικό "
        >
          <Form form={form} onFinish={onFinish} layout="vertical">
            <NewPasswordFields requiredMessage="Παρακαλώ εισάγετε κωδικό" />
            <PasswordSubmitButton form={form}>Επόμενο</PasswordSubmitButton>
          </Form>
        </AuthCard>
      </Spin>
    </AuthLayout>
  );
}
